<template>
  <el-dialog :title="title" :width="calcWidth" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="close" custom-class="default" :show-close="showClose">
    <div slot="title" v-if="showHeader">
      <slot name="header"></slot>
    </div>
    <slot></slot>
    <div slot="footer" class="dialog-footer" :class="footerAlign">
      <el-button @click="close" class="cancelBtn" v-show="showCancelBtn">{{cancelText}}</el-button>
      <el-button type="primary" :loading="confirmLoading" v-show="showConfirmBtn" @click="confirmDialog">{{confirmText}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'dialogInfo',
  props: {
    title: {
      type: String,
      default: '标题'
    },
    visible: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'small'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    showCancelBtn: {
      type: Boolean,
      default: true
    },
    confirmText: {
      type: String,
      default: '确定'
    },
    showConfirmBtn: {
      type: Boolean,
      default: true
    },
    confirmLoading: {
      type: Boolean,
      default: false
    },
    dialogWidth: {
      type: Number,
      default: 0
    },
    footerAlign: {
      type: String,
      default: 'right'
    },
    showHeader: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      dialogVisible: false
    }
  },
  watch: {
    visible: {
      handler (val) {
        this.dialogVisible = val
      },
      immediate: true
    }
  },
  computed: {
    calcWidth () {
      let width
      if (this.dialogWidth > 0) {
        return `${this.dialogWidth}px`
      } else {
        switch (this.size) {
          case 'large': {
            width = '1000px'
            break
          }
          case 'middle': {
            width = '780px'
            break
          }
          default: {
            width = '500px'
          }
        }
        return width
      }
    }
  },
  methods: {
    close () {
      this.$emit('close')
      this.$emit('update:visible', false)
      this.$emit('close', false)
    },
    confirmDialog () {
      this.$emit('confirm', true)
    }
  }
}
</script>

<style lang="less">
.el-dialog{
  .el-dialog__header{
    height: 70px;
    padding: 0 40px;
    background: #F7F8FB;
    line-height: 70px;
    .el-dialog__title{
      font-size: 18px;
      color: #333;
      .el-dialog__headerbtn{
        top: 24px;
        .el-dialog__close{
          font-size: 17px;
        }
      }
    }
  }
  .el-dialog__body{
    padding: 40px 40px 0 40px;
  }
  .el-dialog__footer{
    padding: 37px 40px 40px;
    .dialog-footer{
      .cancelBtn{
        background: #efefef;
        border: none;
        color: #333;
      }
      &.center {
        text-align: center;
      }
    }
  }
}
</style>
